import { motion } from 'framer-motion';

interface Props {
  emoji: string;
  onPress: () => void;
  btnStyle: string;
  delay?: number;
}

export function AnimatedHubButton({ emoji, onPress, btnStyle, delay = 0 }: Props) {
  return (
    <motion.button
      className={`hub-btn ${btnStyle}`}
      onClick={onPress}
      initial={{ scale: 0, opacity: 0 }}
      animate={{
        scale: 1,
        opacity: 1,
        rotate: [0, -14, 14, -14, 14, 0],
      }}
      transition={{
        delay: delay / 1000,
        rotate: {
          duration: 0.35,
          repeat: Infinity,
          repeatDelay: 2.8,
        },
      }}
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.85 }}
    >
      {emoji}
    </motion.button>
  );
}
